export default {
  categories: [],
  subcategories: [],
  category_id: null,
  subcategory_id: null,
  tastes: [],
  sum: 0,
  id: 1,
  error: '',
  comment: '',
  dirty: null,
  files: [],
  europln: 0,
  currency: 'zł',
  lang: 'pl',
};
